import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExitPopup = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M972.815 51.947c-28.526-28.526-74.606-28.526-103.131 0l-357.667 356.938-357.669-357.669c-28.526-28.526-74.606-28.526-103.132 0s-28.526 74.606 0 103.132l357.669 357.669-357.669 357.667c-28.526 28.526-28.526 74.606 0 103.131s74.606 28.526 103.132 0l357.669-357.668 357.667 357.668c28.526 28.526 74.606 28.526 103.131 0s28.526-74.606 0-103.131l-357.668-357.667 357.668-357.669c27.794-27.794 27.794-74.606 0-102.4z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExitPopup);
export default ForwardRef;
